module.exports = __webpack_public_path__ + "static/media/ic_clear_black_24px.16d979e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/CloseButton/ic_clear_black_24px.svg
// module id = 1015
// module chunks = 2